import { URLS } from '@netfoundry-ui/shared/services';

export interface EventsTabRules {
    canReadEvents: () => boolean;
    canReadAlarms: () => boolean;
    isZiti: () => boolean;
}

/** The tab strip the Events pages (management events, network events, notifications) share, on their beta lists. */
export function eventsListTabs(rules: EventsTabRules): { label: string; url: string; hidden: boolean }[] {
    return [
        {
            label: 'Management Events',
            url: URLS.MANAGEMENT_EVENTS_LIST,
            get hidden() {
                return !rules.canReadEvents();
            },
        },
        {
            label: 'Network Events',
            url: URLS.NETWORK_EVENTS_LIST,
            get hidden() {
                return !rules.canReadEvents() || !rules.isZiti();
            },
        },
        {
            label: 'Network Alarms',
            url: URLS.ALARMS,
            get hidden() {
                return !rules.canReadAlarms() || rules.isZiti();
            },
        },
        { label: 'Notifications', url: URLS.NOTIFICATIONS_LIST, hidden: false },
    ];
}
